import { Injectable, Inject, forwardRef } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { from, Observable } from "rxjs";
import { TaxRateMasterRequest, TaxRateMasterRequestInfo } from "src/app/_models/tax-rate/tax-rate-master-request";
import {
  TaxRateComponentRequest,
  TaxRateComponentSaveRequest,
} from "src/app/_models/tax-rate/tax-rate-component-request";
import { TaxSetupRequest } from "src/app/_models/tax-rate/tax-setup-request";
import { setHeader } from "src/app/_helpers/setRequestHeader";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { IApiresponse, IApiRequest, ApiRequest } from "src/app/_models";
import {
  ICartDetailsRequest,
  ICartDetailsResponse,
} from "src/app/_models/organisation-setting/organisation-setting";
import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "../common/claims.service";

@Injectable({
  providedIn: "root",
})
export class TaxRateService {
  orgId: number;
  userId: number;
  organisationCurrency: string;
  claims: Claims;

  constructor(
    private http: HttpClient,
    private header: setHeader,
    private claimsService: ClaimsService,
    private claimsHeaderService: ClaimsHeaderService
  ) {
    this.claimsService.currentClaims.subscribe(
      (claims) => (this.claims = claims)
    );
    this.orgId = this.claims.OrgId;
    this.userId = this.claims.UserId;
    this.organisationCurrency = this.claims.CurrentOrganisationCurrency;
  }
  // httpHeaders =  this.header.createAuthorizationHeader();

  getTaxSetuByOrg(
    taxSetupRequest: TaxSetupRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(taxSetupRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}GetTaxSetup`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((taxRateMaster) => {
          return taxRateMaster;
        })
      );
  }

  getTaxRateMasterByOrgId(
    apiRequest: IApiRequest<TaxRateMasterRequestInfo>
  ): Observable<any> {
    let body = JSON.stringify(apiRequest);
    return this.http
      .post<any>(
        `${environment.billingApiUrl}GetAllTaxRates`,
        body,
        { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
      )
      .pipe(
        map((taxRateMaster) => {
          return taxRateMaster;
        })
      );
  }
  TokenHeader: HttpHeaders;
  saveTaxSetup(
    taxSetupRequest: TaxSetupRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(taxSetupRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}SaveOrUpdateTaxSetup`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((taxRateMaster) => {
          return taxRateMaster;
        })
      );
  }

  getTaxRateComponentsByMasterId(
    taxRateComponentRequest: TaxRateComponentRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(taxRateComponentRequest);
    return this.http
      .post<any>(
        `${environment.billingApiUrl}GetTaxRateComponentsByMasterId`,
        body,
        { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
      )
      .pipe(
        map((taxRateMaster) => {
          return taxRateMaster;
        })
      );
  }

  saveTaxRateMaster(
    taxRateMasterRequest: TaxRateMasterRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(taxRateMasterRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}SaveOrUpdateTaxRateMaster`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((taxRateComponent) => {
          return taxRateComponent;
        })
      );
  }

  saveTaxRateComponent(
    taxRateComponentRequest: TaxRateComponentSaveRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(taxRateComponentRequest);
    return this.http
      .post<any>(
        `${environment.billingApiUrl}SaveTaxRateComponent`,
        body,
        { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
      )
      .pipe(
        map((taxRateComponent) => {
          return taxRateComponent;
        })
      );
  }

  checkForTaxInUse(
    taxRateMasterRequest: TaxRateMasterRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(taxRateMasterRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}CheckForTaxesInUse`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((taxRateMaster) => {
          return taxRateMaster;
        })
      );
  }
  SoloCheckFunctionPurchased(
    functionId: string
  ): Observable<IApiresponse<boolean>> {
    let params = new HttpParams();
    params = params.append("functionId", functionId);
    let url = `${environment.billingApiUrl}CheckFunctionPurchased`;
    return this.http.get<IApiresponse<boolean>>(url, {
      params: params,
      headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
    });
  }

  SaveCartDetails(
    requestinfo: IApiRequest<ICartDetailsRequest>
  ): Observable<IApiresponse<ICartDetailsResponse>> {
    requestinfo.requestInfo.UserId = this.userId;
    requestinfo.requestInfo.OrganisationId = this.orgId;
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ICartDetailsResponse>>(
      `${environment.catalogApiUrl}SaveCartDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  checkExpenseCount(
    requestinfo: any
  ): Observable<any> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ICartDetailsResponse>>(
      `${environment.expenseApiUrl}GetOrgTotalExpenseCountAll`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }
}
